import { MCP_SERVERS } from "config";

/**
 * Returns the oauth_scopes string for the MCP server with the given URL, or ""
 * if not found. Reads the static `MCP_SERVERS` rather than the live persona
 * `mcpConfig`, which is safe because persona configs derive every server entry
 * from `MCP_SERVERS` (see `src/types/personas/*.ts` and the merge in
 * `useChatStream`), so the scopes for a given URL cannot diverge.
 *
 * The poller does not call this: it reads the `oauthScopes` column off the
 * long-task row and nothing else. The one caller is
 * `buildLongTaskSubmitEntry`, which calls it to populate that column when the
 * row is created (ADR 059, "statusTool resolution").
 */
export function oauthScopesForServer(serverUrl: string): string {
  const entry = Object.values(MCP_SERVERS).find((s) => s.url === serverUrl);
  return entry?.oauth_scopes ?? "";
}
